export function nextCorplinksProfileVersion(currentRef, profileID) {
  if (currentRef?.id !== profileID) return "1.0.0";
  const match = /^(\d+)\.(\d+)\.(\d+)$/.exec(currentRef.version || "");
  if (!match) throw new Error("Версия профиля изменилась. Обновите настройки агента.");
  return `${match[1]}.${match[2]}.${Number(match[3]) + 1}`;
}

export function availableCorplinksModels(agent, stage, prices) {
  const extendedSearch = agent.solution.solutionId === "solution_corplinks_company_reference_extended" && stage.id === "analysis";
  const seen = new Set();
  return prices.filter((item) => {
    const key = `${item.provider}:${item.model}`;
    if (seen.has(key) || !["openai", "anthropic"].includes(item.provider) ||
      (agent.builds[0]?.budget?.currency && item.currency !== agent.builds[0].budget.currency)) return false;
    const rates = new Set((item.rates || []).map((rate) => rate.metric));
    if (!rates.has("input_tokens") || !rates.has("output_tokens") ||
      (extendedSearch && (item.provider !== "openai" || !rates.has("web_search_requests")))) return false;
    seen.add(key);
    return true;
  });
}

export function editedCorplinksBindings(agent, selection, prices, profileID, version) {
  const stages = agent.builds[0]?.activeStages || agent.builds[0]?.stages || [];
  if (!stages.length) throw new Error("Этапы агента не загружены.");
  const previous = new Map((agent.profile?.bindings || []).map((binding) =>
    [binding.selector?.role || binding.selector?.stageId, binding]));
  const bindings = stages.map((stage) => {
    const selected = availableCorplinksModels(agent, stage, prices).find((item) =>
      `${item.provider}:${item.model}` === selection[stage.id]);
    if (!selected) throw new Error(`Модель для этапа «${stage.title || stage.id}» недоступна в тарифах.`);
    const old = previous.get(stage.id) || {};
    const extendedSearch = agent.solution.solutionId === "solution_corplinks_company_reference_extended" && stage.id === "analysis";
    return { selector: { role: stage.id }, primary: { providerRef: selected.provider, modelRef: selected.model,
      modelBindingRef: `${profileID}-${stage.id}-${version}` }, failover: [],
      requirements: { ...(old.requirements || {}), structuredOutput: true, ...(extendedSearch ? { webSearch: true } : {}) },
      limits: { maxInputTokens: Math.max(32000, old.limits?.maxInputTokens || 0),
        maxOutputTokens: stage.maxOutputTokens || 8000, timeoutSeconds: old.limits?.timeoutSeconds || 90 },
      policy: { reasoning: old.policy?.reasoning || stage.reasoningEffort || "none",
        toolSearch: extendedSearch ? "required" : old.policy?.toolSearch || "disabled",
        maxProviderAttempts: old.policy?.maxProviderAttempts || 1 } };
  });
  if (bindings.length === 2 && bindings[0].primary.providerRef === bindings[1].primary.providerRef) {
    throw new Error("Анализ и проверка должны использовать разных провайдеров.");
  }
  return bindings;
}
